var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import styled from "styled-components";
import { CouponBtn } from "./CouponBtn";
const SingleWrapper = styled.div `
	font-size: 0px;
	img {
		width: 100%;
	}
`;
export const Single = (props) => {
    const { coupons = [] } = props, others = __rest(props, ["coupons"]);
    return (React.createElement(React.Fragment, null, coupons.map((item, index) => {
        return (React.createElement(SingleWrapper, { key: index },
            React.createElement(CouponBtn, Object.assign({ index: index, coupon: item }, others))));
    })));
};
